import { HttpErrorResponse } from '@angular/common/http';
import { ProductSettingsDTO } from '@modeso/types__dgoods-products';
import { createAction, props } from '@ngrx/store';

export const getProductsSettings = createAction('[Product Settings] Load Product Settings');

export const getProductsSettingsSuccess = createAction(
    '[Product Settings] Load Product Settings Success',
    props<{ productsSettings: ProductSettingsDTO[] }>(),
);

export const getProductsSettingsFailure = createAction(
    '[Product Settings] Load Product Settings Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const clearProductsState = createAction('[Product] Clear Products State');

export const clearRequestState = createAction('[Product] Clear Requests State');

export const updateProductSettings = createAction(
    '[Product Settings] Update Product Settings',
    props<{ productsSettings: ProductSettingsDTO }>(),
);
export const updateProductSettingsSuccess = createAction(
    '[Product Settings] Update Product Settings Success',
    props<{ productsSettings: ProductSettingsDTO }>(),
);
export const updateProductSettingsFailure = createAction(
    '[Product Settings] Update Product Settings Failure',
    props<{ error: HttpErrorResponse }>(),
);
